import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingCart, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-4 py-12">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-md bg-white rounded-[2rem] border border-slate-100 shadow-xl p-10 text-center"
        data-testid="payment-cancel-page"
      >
        <span className="inline-grid place-items-center w-20 h-20 rounded-full bg-amber-100 text-amber-500 mx-auto">
          <ShoppingCart className="w-12 h-12" />
        </span>
        <h1 className="font-heading font-black text-3xl text-slate-900 mt-6">Paiement annulé</h1>
        <p className="text-slate-500 mt-2">
          Aucun montant n'a été débité. Votre panier vous attend toujours.
        </p>
        <div className="flex flex-col gap-3 mt-8">
          <Link to="/panier" className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-sky-500 text-white font-bold hover:bg-sky-600 transition-colors">
            Retourner au panier
          </Link>
          <Link to="/boutique" className="inline-flex items-center justify-center gap-2 text-sky-600 font-bold">
            <ArrowLeft className="w-4 h-4" /> Continuer mes achats
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
